// extracted by mini-css-extract-plugin
var _1 = "ApplicantDecisionApplicant-moduleApplicantDecisionApplicant__TInzd";
var _2 = "ApplicantDecisionApplicant-moduleactions__eVKm1 ApplicantDecisionActions-moduleApplicantDecisionActions__jgO2M";
var _3 = "ApplicantDecisionApplicant-modulename__ddFam";
export { _1 as "ApplicantDecisionApplicant", _2 as "actions", _3 as "name" }
